import React from "react";
import { getInitials, getInitial } from "../../services/utils/name-utils";
import TimeTableWeekEvents from "./Time-table-week-events";
import "../../styles/weekEvents.css";
import { Tooltip } from "@mui/material";
/**
 * sets how to display week based events on the sj schedule week view component
 * @param {*} param0
 * @returns
 */

const TimeTableWeekEvent = ({ event }) => {
  console.log("Event in week", event)
  var diff = Math?.abs(event?.EndTime?.getTime() - event?.StartTime?.getTime());
  var minutes = Math?.round(diff / 60000);
  const currentTime = new Date();
  // const getInitial=(name)=> {
  //   if(name){
  //       const parts = name?.split(' ');
  //       const firstName = parts[1];
  //       const initial = firstName ? firstName.charAt(0).toUpperCase() : '';
  //       return initial;
  //   }
  //   else{
  //       return ""
  //   }
  // }
  // determines if event is after currently happening based on current time
  const isHappened = currentTime.getTime() > event?.EndTime?.getTime();
  if (minutes <= 30) {
    return event ? (
      // if minutes is less than 30, it'll have less space to show
      <div
        className="week-template-wrap"
      >
        <div className="cotainer">
          <div className="row">
            <div className="col-md-6">
              {isHappened && event.Events[0] === "Planner" && (
                <div className="">
                  <div className="lectype" style={{ color: event.DisplayColor, marginLeft: "2px" }}>Study Planner</div>
                  <div className="sbj2" style={{ color: event.DisplayColor, marginLeft: "2px" }}>{event.Subject}</div>
                </div>
              )}
              {event.Events[0] === "Planner" && !isHappened && (
                <div className="">
                  <div className="lectype" style={{ color: event.DisplayColor, marginLeft: "2px" }}>Study Planner</div>
                  <div className="sbj2" style={{ color: event.DisplayColor, marginLeft: "2px" }}>{event.Subject}</div>
                </div>
              )}

              {(event.lectureType === "general_category" && event.Events[0] !== "Planner") && (
                <Tooltip
                  title={event.lectureName.toUpperCase()}
                  arrow
                  placement="bottom"
                  enterDelay={200}
                  leaveDelay={100}
                >
                  <div className="weekStyle">
                    {event.lectureName.toUpperCase()}
                  </div>
                </Tooltip>
                // <div className="">{}</div>
              )}
              {(event.lectureType !== "general_category" && event.Events[0] !== "Planner") && (
                <Tooltip
                  title={event.Subject}
                  arrow
                  placement="bottom"
                  enterDelay={200}
                  leaveDelay={100}
                >
                  <div className="sbj1 px-1">
                    {event.Subject}
                  </div>
                </Tooltip>
                // <div className="">{}</div>
              )}

              <div className="row d-flex">
                <TimeTableWeekEvents event={event} />
              </div>
            </div>
            {/* Show event in 4 cols */}

            {/* Teacher */}
            <div className="col ml-4 mt-1">
              {event?.Teacher?.name && (
                <div className="crcl mr-1">
                  <Tooltip
                    title={event?.Teacher?.name}
                    arrow
                    placement="top"
                    enterDelay={200}
                    leaveDelay={100}
                  >
                    <span className="inti">
                      {getInitial(event?.Teacher?.name)}
                    </span>
                  </Tooltip>
                </div>
              )}
            </div>
          </div>
        </div>
      </div >
    ) : (
      <></>
    );
  } else {
    return event ? (
      // take full space available for show event
      <div className="p-1">
        <div className="row">
          {/* Subject */}
          <div className="col-md-7">
            {(event.lectureType === "general_category" && event.Events[0] !== "Planner") ? (
              <Tooltip
                title={event.lectureName.toUpperCase()}
                arrow
                placement="bottom"
                enterDelay={200}
                leaveDelay={100}
              >
                <div className="weekStyle">
                  {event.lectureName.toUpperCase()}
                </div>
              </Tooltip>
            ) : (
              <Tooltip
                title={event.Subject}
                arrow
                placement="bottom"
                enterDelay={200}
                leaveDelay={100}
              >
                <div className="sbj1 px-1">
                  {event.Subject}
                </div>
              </Tooltip>
            )}
            {isHappened && event.Events[0] === "Planner" && (
              <div className="p-2">
                <div className="lectype" >Special Lecture</div>
                <div className="sbj3">{event.Subject}</div>
              </div>
            )}
            {event.Events[0] === "Planner" && !isHappened && (
              <div className="p-2">
                <div className="lectype" style={{ color: event.DisplayColor }}>Study Planner</div>
                <div className="sbj2" style={{ color: event.DisplayColor }}>
                  {event.Subject}
                </div>
              </div>
            )}
            <div className="row events_Hours_weeek d-flex">
              <TimeTableWeekEvents event={event} />
            </div>
          </div>
          {/* Teacher */}
          <div className="col ml-4">
            {event?.Teacher?.name && (
              <div className="crcl mr-1">
                <Tooltip
                  title={event?.Teacher?.name}
                  arrow
                  placement="top"
                  enterDelay={200}
                  leaveDelay={100}
                >
                  <span className="inti">
                    {getInitial(event?.Teacher?.name)}
                  </span>
                </Tooltip>
              </div>
            )}
          </div>
        </div>
        {/* Take full size to show event data */}
      </div>
    ) : (
      <></>
    );
  }
};

export default TimeTableWeekEvent;
